import { FaAddressBook } from "react-icons/fa";
import { ContactsViewMain } from "../Components/ContactsViewMain";

export const ContactsModule = () => [
    {
        views: "PRIVATE", path: "/contacts", component: <ContactsViewMain />,
        roles: null, permissions: null, label: "Contactos", icon: <FaAddressBook />,
        displayInHeader: false, displayInFooter: false, displayInSidebar: true,
        isBlockedWhenLogged: false,
    },
];
